import { getReportDefinition } from '../config/report-definitions';
import type { ReportDateRange, ReportType } from '../types/report.types';

/** Display + filename title including the selected period (e.g. "Financial Summary — Last Financial Year"). */
export function buildReportDisplayTitle(reportType: ReportType, period: ReportDateRange): string {
  const def = getReportDefinition(reportType);
  const base = def?.title ?? reportType;
  return `${base} — ${period.label}`;
}
